export default {
  "name": "NCLabel",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCLabel",
  "label": "文本",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "title": {
        "title": "title",
        "description": "title",
        "type": "string"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}